(function(){
'use strict';
var root=document.querySelector('[data-fmy-offers][data-offer-mode="promotion"]');
if(!root||root.dataset.finalDayReady==='true')return;
var panel=root.querySelector('[data-fo-last-day]'),
heading=root.querySelector('[data-fo-pill-heading]'),
hours=root.querySelector('[data-fo-hours]'),
mins=root.querySelector('[data-fo-minutes]'),
secs=root.querySelector('[data-fo-seconds]'),
label=root.querySelector('[data-fo-timer-label]'),
daysElement=root.querySelector('[data-fo-days]'),
button=root.querySelector('[data-fo-open]');
if(!panel||!heading||!hours||!mins||!secs||!button)return;
var endEpoch=Number(root.dataset.foEndEpoch),endMs=endEpoch*1000;
if(!Number.isFinite(endMs)||endEpoch<=0)return;
root.dataset.finalDayReady='true';
var defaultHeading=heading.textContent,
previewAllowed=root.dataset.foDesignMode==='true'&&root.dataset.foPreview==='true',
pillTemplate=root.dataset.foPillTemplate||'ENDS IN {time}',
barLabel=root.dataset.foBarLabel||'FINAL DAY · ENDS IN',
formatter;
try{formatter=new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'});}catch(e){return;}
var lastDayET=formatter.format(new Date(endMs-1000)),
timer=null,refreshed=false;
// Draw true seven-segment clock numerals without loading a custom font.
// Keep every segment in the DOM; only toggle its on/off class once a second.
var svgNS='http://www.w3.org/2000/svg';
var segments=[
 '3,1 11,1 9.5,2.7 4.5,2.7',           // top
 '11.5,2 13,3.5 12.5,10.9 10.7,12 10.7,3.8', // upper right
 '10.7,13 12.5,14.1 13,21.5 11.5,23 10.7,21.2', // lower right
 '3,24 11,24 9.5,22.3 4.5,22.3',       // bottom
 '2.5,13 3.3,14.1 3.3,21.2 1.5,23 1,21.5', // lower left
 '1.5,2 3.3,3.8 3.3,10.9 2.5,12 1,10.9', // upper left
 '3.3,12.5 4.8,11.7 9.2,11.7 10.7,12.5 9.2,13.3 4.8,13.3' // middle
];
var numeralBits=[
 '1111110','0110000','1101101','1111001','0110011',
 '1011011','1011111','1110000','1111111','1111011'
];
function initClockNumber(node,unit){
 node.classList.add('fmy-seven-segment-number');
 var digits=[],fragment=document.createDocumentFragment();
 for(var k=0;k<2;k++){
  var svg=document.createElementNS(svgNS,'svg');
  svg.setAttribute('viewBox','0 0 14 25');
  svg.setAttribute('class','fmy-seven-segment-digit');
  svg.setAttribute('aria-hidden','true');
  svg.setAttribute('focusable','false');
  var parts=[];
  for(var seg=0;seg<7;seg++){
   var p=document.createElementNS(svgNS,'polygon');
   p.setAttribute('points',segments[seg]);
   p.setAttribute('class','fmy-seven-segment-part');
   svg.appendChild(p);parts.push(p);
  }
  fragment.appendChild(svg);digits.push(parts);
 }
 var reader=document.createElement('span');
 reader.setAttribute('class','fmy-offers__sr-only');
 fragment.appendChild(reader);
 node.textContent='';
 node.appendChild(fragment);
 return function(value){
  value=String(value).padStart(2,'0').slice(-2);
  reader.textContent=value+' '+unit;
  for(var x=0;x<2;x++){
   var idx=value.charCodeAt(x)-48;
   var bits=numeralBits[idx]||numeralBits[0];
   for(var y=0;y<7;y++)digits[x][y].classList.toggle('is-lit',bits.charAt(y)==='1');
  }
 };
}
var renderHours=initClockNumber(hours,'hours');
var renderMinutes=initClockNumber(mins,'minutes');
var renderSeconds=initClockNumber(secs,'seconds');
function pad(n){return String(n).padStart(2,'0');}
function PillCopy(template,time){
 template=(template||'').trim();
 if(!template)return time;
 if(/\{time\}/i.test(template))return template.replace(/\{time\}/gi,time);
 return template+' '+time;
}
function displayFinalDay(on){
 panel.hidden=!on;
 root.dataset.foLastDayActive=on?'true':'false';
 if(!on){
  heading.textContent=defaultHeading;
  button.setAttribute('aria-label','View current 4MYTU offers');
 }else{
  button.setAttribute('aria-label','Final day: current promotion ends tonight. View offers');
 }
}
function tick(){
 if(timer){clearTimeout(timer);timer=null;}
 var now=Date.now(),left=endMs-now;
 if(left<=0){
  displayFinalDay(false);
  // At the deadline, stop displaying expired offers and rerender regular pricing/welcome mode once.
  root.hidden=true;
  var key='fmy-promo-expiry-reload-'+String(endEpoch),already=false;
  try{already=sessionStorage.getItem(key)==='yes';if(!already)sessionStorage.setItem(key,'yes');}catch(e){}
  if(!already&&!refreshed){refreshed=true;window.location.reload();}
  return;
 }
 var isLastDay=formatter.format(new Date(now))===lastDayET,show=previewAllowed||isLastDay;
 displayFinalDay(show);
 if(show){
  // Both Header and Floating Center now count down from exactly the same
  // Promotion Control deadline. Preview only forces visibility, never changes time.
  var seconds=Math.max(0,Math.ceil(left/1000));
  var d=Math.floor(seconds/86400),h=Math.floor((seconds%86400)/3600);
  var m=Math.floor((seconds%3600)/60),s=seconds%60;
  renderHours(pad(h));renderMinutes(pad(m));renderSeconds(pad(s));
  var timeText=pad(h)+':'+pad(m)+':'+pad(s);
  var formatted=PillCopy(pillTemplate,timeText);
  var previewBeforeFinalDay=previewAllowed&&!isLastDay;
  if(daysElement){
    daysElement.hidden=d===0;
    daysElement.textContent=String(d).padStart(2,'0')+'D';
  }
  // A compact preview label keeps the floating badge readable on mobile.
  // "01D 01:34:41" is identical to Header's "01 DAY 01 HRS 34 MIN 41 SEC".
  heading.textContent=previewBeforeFinalDay?'PREVIEW '+(d>0?d+'D ':'')+timeText:formatted;
  label.textContent=previewBeforeFinalDay?'PREVIEW · ENDS IN':barLabel;
 }
 timer=window.setTimeout(tick,show?1000:15000);
}
document.addEventListener('visibilitychange',function(){if(!document.hidden)tick();});
tick();
})();
